import * as types from '@/generated'
import { filterNotNull } from '@/util'
import { FilterFragment } from '@/ux/Filter/Filter.generated'

export const normalisePrimaryPageFilters = (
  currentPrimaryPageFilters: FilterFragment[],
  fetchedPrimaryPageFilters: FilterFragment[],
  primaryPageFilterIds: string[],
  appKey: string
) => {
  const reUsedFilters =
    currentPrimaryPageFilters.filter((filter) => {
      if (filter) {
        if (primaryPageFilterIds?.includes(filter?.id.replace('/' + appKey, ''))) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }) ?? []

  const newFilters =
    fetchedPrimaryPageFilters?.filter((filter) => {
      if (filter) {
        if (reUsedFilters?.map((filter) => filter.id).includes(filter.id)) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    }) ?? []

  return reUsedFilters.concat(newFilters)
}

export const removeNullFilters = (filterData?: FilterFragment[]) => {
  if (!filterData) return []
  return filterData.filter((x): x is FilterFragment => x !== null) ?? []
}

const _optionToInput = (option: types.SelectOption | null | undefined): types.SelectOptionInput | undefined => {
  return option
    ? {
        value: option.value,
        label: option.label,
      }
    : undefined
}

export const buildFilterInputs = (filters: FilterFragment[]): types.FieldInput[] => {
  return filters.map((filter) => {
    let tag: types.FieldTag = types.FieldTag.UnknownField
    switch (filter.__typename) {
      // TODO prefer lookup / dictionary to avoid this long switch
      case 'BooleanField':
        tag = types.FieldTag.BooleanField
        break
      case 'MultiSelectField':
        tag = types.FieldTag.MultiSelectField
        break
      case 'NumberField':
        tag = types.FieldTag.NumberField
        break
      case 'NumberRangeField':
        tag = types.FieldTag.NumberRangeField
        break
      case 'SelectField':
        tag = types.FieldTag.SelectField
        break
      case 'TextField':
        tag = types.FieldTag.TextField
        break
      case 'UploadFileField':
        tag = types.FieldTag.UploadFileField
        break
    }
    return {
      id: filter.id ?? '',
      tag,
      text: filter.__typename === 'TextField' ? (filter.localText ?? filter.text) : undefined,
      value: filter.__typename === 'NumberField' ? (filter.localValue ?? filter.value) : undefined,
      // TODO state: filter.__typename === "BooleanField" ? filter.state : undefined,
      // TODO range: filter.__typename === "NumberRangeField" ? filter.range : undefined,
      selection:
        filter.__typename === 'SelectField'
          ? // convert selection to input
            _optionToInput(filter.localSelection ?? filter.selection)
          : undefined,
      selections:
        filter.__typename === 'MultiSelectField'
          ? filterNotNull(
              // convert selections to inputs
              (filter.localSelections ?? filter.selections)?.map((selection) => _optionToInput(selection)) ?? []
            )
          : undefined,
    }
  })
}
